import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { useCookies } from "react-cookie";
import axios from "axios";
import $ from "jquery";

export default function AddBookToLibrary() {

    let { libraryId, bookid } = useParams();

    useEffect(() => {
        axios.post(`https://cloudify-backend.herokuapp.com/libraries/books/add/${libraryId}`, {
            bookId: bookid
        })
        .then(resp => {
            console.log(resp.data)
        })
    }, [])

    return (
        <h1>Adicionando livro...</h1>
    )
}